"use strict";

exports.__esModule = true;
exports.ComboChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _d3Selection = require("d3-selection");
var _scales = require("../scales");
var _Axis = require("../Axis");
var _Series = require("../Series");
var _timeDefinitions = require("../../timeDefinitions");
var _excluded = ["createXScale", "createYScale", "xAxisHeight", "yAxisWidth", "series", "padding", "width", "height", "showXAxis", "showYAxis", "yTickCount", "xTickCount", "xTickFormat", "showReferenceLine"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var createStateFromProps = function createStateFromProps(props) {
  var series = props.series,
    width = props.width,
    height = props.height,
    padding = props.padding,
    yAxisWidth = props.yAxisWidth,
    xAxisHeight = props.xAxisHeight,
    showXAxis = props.showXAxis,
    showYAxis = props.showYAxis,
    orientation = props.orientation,
    createXScaleCustom = props.createXScale,
    createYScaleCustom = props.createYScale,
    referenceLineValue = props.referenceLineValue,
    showReferenceLine = props.showReferenceLine;
  var createYScale;
  var createXScale;
  if (orientation === "vertical") {
    // vertical creates the linear scale (the data axis) on the Y axis
    createYScale = createYScaleCustom || _scales.createLinearScale;
    createXScale = createXScaleCustom || _scales.createBandScale;
  } else {
    // horizontal creates the linear scale (the data axis) on the X axis
    createYScale = createYScaleCustom || _scales.createBandScale;
    createXScale = createXScaleCustom || _scales.createLinearScale;
  }
  var bodyX = padding;
  var bodyY = padding;
  var bodyHeight = height - padding * 2;
  var bodyWidth = width - padding * 2;
  if (showYAxis) {
    bodyHeight -= xAxisHeight;
  }
  if (showXAxis) {
    bodyWidth -= yAxisWidth;
    bodyX += yAxisWidth;
  }
  var xScale;
  var yScale;
  if (series.length > 0) {
    var firstSeries = series[0];
    xScale = createXScale(0,
    // bodyX,
    bodyWidth, firstSeries.data.map(function (item) {
      return typeof firstSeries.getXValue === "function" ? firstSeries.getXValue(item) : item.x;
    }));
    var data = series.flatMap(function (s) {
      return s.data.map(function (item) {
        return typeof s.getYValue === "function" ? s.getYValue(item) : item.y;
      });
    });
    if (showReferenceLine) data.push(referenceLineValue == null ? 0 : referenceLineValue);
    yScale = createYScale(bodyHeight, 0,
    // bodyY,
    data);
  } else {
    xScale = createXScale(0, bodyWidth, []);
    yScale = createYScale(bodyHeight, 0, []);
  }
  return {
    width: width,
    height: height,
    padding: padding,
    showXAxis: showXAxis,
    showYAxis: showYAxis,
    createXScale: createXScale,
    createYScale: createYScale,
    bodyX: bodyX,
    bodyY: bodyY,
    bodyHeight: bodyHeight,
    bodyWidth: bodyWidth,
    xScale: xScale,
    yScale: yScale,
    series: series
  };
};
function getXValue(input) {
  return input.x;
}
function getYValue(input) {
  return input.y;
}
function defaultRender(props) {
  return /*#__PURE__*/_react["default"].createElement(_Series.LineChartSeries, props);
}
function normalizeSeries(series) {
  return Object.assign({
    getXValue: getXValue,
    getYValue: getYValue,
    render: defaultRender
  }, series);
}

/**
 * A render-prop powered combination chart.
 */
// eslint-disable-next-line no-shadow
var ComboChart = exports.ComboChart = /*#__PURE__*/function (_Component) {
  function ComboChart() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = createStateFromProps(_this.props);
    _this.registerContainer = function (container) {
      _this.container = container;
      if (container != null) {
        ComboChart.applyValues(container);
      }
    };
    _this.generateReferenceLineSeries = function () {
      var data = [];
      var start = _this.props.series[0].data[0].interval.startMillis;
      var end = Date.now() + 1000;
      data.push({
        value: _this.props.referenceLineValue,
        interval: {
          startMillis: start - _timeDefinitions.DAY_IN_MILLIS,
          endMillis: end
        }
      });
      data.push({
        value: _this.props.referenceLineValue,
        interval: {
          startMillis: end,
          endMillis: end
        }
      });
      return data;
    };
    return _this;
  }
  _inheritsLoose(ComboChart, _Component);
  ComboChart.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    if (prevState.width === props.width && prevState.height === props.height && prevState.padding === props.padding && prevState.showXAxis === props.showXAxis && prevState.showYAxis === props.showYAxis && prevState.createXScale === props.createXScale && prevState.createYScale === props.createYScale && (0, _reactFastCompare["default"])(prevState.series, props.series)) {
      return null;
    }
    return createStateFromProps(props);
  };
  ComboChart.applyValues = function applyValues(container) {
    var g = (0, _d3Selection.select)(container);
    g.selectAll(".combo").remove().attr("class", "combo");
  };
  var _proto = ComboChart.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      createXScale = _this$props.createXScale,
      createYScale = _this$props.createYScale,
      xAxisHeight = _this$props.xAxisHeight,
      yAxisWidth = _this$props.yAxisWidth,
      series = _this$props.series,
      padding = _this$props.padding,
      width = _this$props.width,
      height = _this$props.height,
      showXAxis = _this$props.showXAxis,
      showYAxis = _this$props.showYAxis,
      yTickCount = _this$props.yTickCount,
      xTickCount = _this$props.xTickCount,
      xTickFormat = _this$props.xTickFormat,
      showReferenceLine = _this$props.showReferenceLine,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var _this$state = this.state,
      bodyX = _this$state.bodyX,
      bodyY = _this$state.bodyY,
      bodyWidth = _this$state.bodyWidth,
      bodyHeight = _this$state.bodyHeight,
      xScale = _this$state.xScale,
      yScale = _this$state.yScale;
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      width: width,
      height: height
    }, extra, {
      ref: this.registerContainer,
      "data-testid": "ComboChart"
    }), series.map(normalizeSeries).map(function (item, key) {
      return item.render({
        key: key,
        series: item,
        x: bodyX,
        y: bodyY,
        width: bodyWidth,
        height: bodyHeight,
        xScale: xScale,
        yScale: yScale
      });
    }), showYAxis && /*#__PURE__*/_react["default"].createElement(_Axis.Axis, {
      x: padding,
      y: padding,
      height: height,
      width: yAxisWidth,
      scale: yScale,
      tickCount: yTickCount,
      orientation: "LEFT",
      style: {
        overflow: "visible"
      }
    }), showXAxis && /*#__PURE__*/_react["default"].createElement(_Axis.Axis, {
      x: padding + (showYAxis ? yAxisWidth : 0),
      y: padding + bodyHeight,
      height: xAxisHeight,
      width: bodyWidth,
      scale: xScale,
      tickCount: xTickCount,
      orientation: "BOTTOM",
      style: {
        overflow: "visible"
      },
      tickFormat: xTickFormat
    }), showReferenceLine ? /*#__PURE__*/_react["default"].createElement(_Series.LineChartSeries, {
      width: bodyWidth,
      height: bodyHeight,
      x: bodyX,
      y: bodyY,
      color: "#000000",
      strokeDasharray: "5 10",
      series: {
        data: this.generateReferenceLineSeries(),
        getXValue: function getXValue(item) {
          return item.interval.startMillis;
        },
        getYValue: function getYValue(item) {
          return item.value;
        }
      },
      xScale: xScale,
      yScale: yScale,
      showChartTooltip: false,
      curve: "stepAfter"
    }) : null);
  };
  return ComboChart;
}(_react.Component);
ComboChart.defaultProps = {
  padding: 4,
  xAxisHeight: 30,
  yAxisWidth: 45,
  showXAxis: true,
  showYAxis: true,
  orientation: "vertical"
};